import axios from "axios";

export const getBusinessAccount = async ({ queryKey }) => {
  const [, userId, token] = queryKey;
  const response = await axios.get(
    process.env.REACT_APP_API_URL + "/developer-accounts/merchant/" + userId,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );

  return response;
};

export const getSchoolLink = async ({ queryKey }) => {
  const [, apiKey, apiToken, token] = queryKey;
  const response = await axios.get(
    process.env.REACT_APP_API_TRANSACTION + "/schools/link",
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "x-api-key": apiKey,
        "X-API-TOKEN": apiToken,
      },
    },
  );

  return response;
};

export const createNewPaymentLink = ({ queryKey, requestData }) => {
  const [, apiKey, apiToken, token] = queryKey;
  const response = axios.post(
    process.env.REACT_APP_API_TRANSACTION + "/schools/link",
    requestData,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "x-api-key": apiKey,
        "X-API-TOKEN": apiToken,
      },
    },
  );
  return response;
};
